import React from 'react'
import styled from 'styled-components'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'

import { StreamEmblem, StreamLogo } from 'components'
import { usePageContext } from 'contexts/Page'
import { Box } from 'components/Box'
import { FooterCredit } from 'components/FooterCredit'

const Root = styled(Box).attrs({
  marginTop: 4,
  paddingY: 2,
})`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  z-index: 10;
  text-align: center;
`

const Logo = styled(StreamEmblem)`
  margin-right: 1rem;
`

const EventLogo = styled(GatsbyImage)`
  margin-left: 1.25rem;
  flex-shrink: 0;
`

export const Footer = () => {
  const context = usePageContext()
  const event = context?.tutorial?.event

  if (event) {
    const logo = getImage(event.childMdx.frontmatter.footerLogo)
    return (
      <>
        <Root>
          <Logo />
          <span role="img">{'❤️'}</span>
          <a
            name={event.name}
            href={event.url}
            target="_blank"
            rel="noreferrer"
          >
            <EventLogo image={logo} />
          </a>
        </Root>
        <FooterCredit />
      </>
    )
  }

  return (
    <>
      <Root>
        <StreamLogo size={1} />
      </Root>
      <FooterCredit />
    </>
  )
}
